<template>
  <div>
      <el-table
            :data="$store.getters.getInventoryMasterDataProps.variant_list"
            style="width: 100%">
          <el-table-column 
            prop="variant_sub_item_id"
            label="Variant Type">
            <template slot-scope="scope">
                <el-select 
                    :id="'variant_sub_item_id_'+scope.row.key"
                    size="small"
                    v-model="scope.row.variant_sub_item_id" 
                    filterable style="text-align: left;">
                    <el-option-group
                      v-for="dataGroup in $store.getters.getInventoryVariantList"
                      :key="dataGroup.id">
                      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                          <span style="float: left; padding-left: 5px;" v-html="dataGroup.variant_name"></span>
                          <el-option
                              v-for="item in dataGroup.sub_variant_list"
                              :key="item.id"
                              :label="dataGroup.variant_name+' -> '+item.sub_variant_name"
                              :value="item.id">
                              <span style="float: left" v-html="item.sub_variant_name"></span>
                          </el-option>
                      </div>
                    </el-option-group>
                </el-select>
            </template>
            </el-table-column>
            
            <!--<el-table-column 
            prop="other_variations"
            label="Other Variations" 
            v-if="$store.getters.getInventoryMasterDataProps.id === 0">
            <template slot-scope="scope">
              <el-select 
                  v-if="scope.row.variant_sub_item_id>0"
                  size="small"
                  v-model="scope.row.other_variations"
                  filterable 
                  multiple 
                  placeholder="Select">
                    <el-option
                      v-for="(item, index) in getAllVariants.filter(t => t.variant_id === getAllVariants.filter(t => t.sub_variant_id === scope.row.variant_sub_item_id)[0].variant_id)"
                      :key="index"
                      :label="item.sub_variant_name"
                      :value="item.sub_variant_id">
                      <span style="float: left" v-html="item.sub_variant_name"></span>
                    </el-option>
              </el-select>
            </template>
            </el-table-column>-->
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addNewInventoryMasterVariantListRow')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterVariantListRow', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    computed: {
      getAllVariants() {
         let list = [];

          JSON.parse(JSON.stringify(this.$store.getters.getInventoryVariantList)).forEach(element => {
              element.sub_variant_list.forEach(variant => {
                  list.push({
                      variant_id: element.id,
                      sub_variant_id: variant.id,
                      sub_variant_name: variant.sub_variant_name,
                  })
              })
          })
         return list
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/VariantList.vue